export default __webpack_public_path__ + "static/copper_prices-cda86bfc144112a1f02477166a75a0e0.png";